// Pure helpers shared by the venue reviews UI (detail sections, listing badge, filters, Historial).

export const REVIEW_COMMENT_MAX = 500;

/**
 * Multi-select rating filter of the listings (bars, clubs, salons). The selected tokens are sent
 * to the API as the CSV query param `ratingRanges`; the backend ORs them and an empty selection
 * means "no rating filter".
 */
export const RATING_RANGE_OPTIONS = [
  { value: "4-5", label: "4 a 5 ★" },
  { value: "3-4", label: "3 a 4 ★" },
  { value: "0-3", label: "Menos de 3 ★" },
];

/** Label of one range token ("" for an unknown token). */
export const ratingRangeLabel = (value) =>
  RATING_RANGE_OPTIONS.find((o) => o.value === String(value))?.label || "";

/** Selected tokens -> `ratingRanges` CSV value ("" when nothing is selected). */
export const ratingRangesParam = (values) => (Array.isArray(values) ? values.join(",") : "");

/** 4.8 -> "4,8"; 5 -> "5,0". Anything that is not a finite number -> "". */
export const formatRating = (avg) => {
  const n = Number(avg);
  if (avg === null || avg === undefined || avg === "" || !Number.isFinite(n)) return "";
  return n.toFixed(1).replace(".", ",");
};

/** Whether a venue payload has reviews worth showing (badge, summary). */
export const hasRating = (venue) => Number(venue?.ratingCount) > 0 && Number(venue?.ratingAvg) > 0;

/** "1 reseña" / "32 reseñas". */
export const reviewsCountLabel = (count) => `${count} ${Number(count) === 1 ? "reseña" : "reseñas"}`;

/** "Septiembre 2026" (capitalized, Argentina locale). Invalid date -> "". */
export const reviewMonthLabel = (createdAt) => {
  const d = new Date(createdAt);
  if (Number.isNaN(d.getTime())) return "";
  const text = new Intl.DateTimeFormat("es-AR", { month: "long", year: "numeric", timeZone: "America/Argentina/Buenos_Aires" })
    .format(d)
    .replace(" de ", " ");
  return text.charAt(0).toUpperCase() + text.slice(1);
};

/** Beauty tag: "Corte mujer · con Sofi"; empty string when there is nothing to show. */
export const reviewTagLabel = (tag) => {
  if (!tag) return "";
  const services = Array.isArray(tag.services) ? tag.services.filter(Boolean).join(" + ") : "";
  const pro = tag.professionalName ? `con ${tag.professionalName}` : "";
  return [services, pro].filter(Boolean).join(" · ");
};
